import React from "react";

const CreditPage = ({ children }) => {
  const isCredit = process.env.REACT_APP_CREDIT == 1;
  return isCredit ? <></> : children;
};

export default CreditPage;
